"use strict";

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChainIdByNetwork = exports.isValidChainId = exports.isCoinbaseProvider = exports.isDapperProvider = exports.isCucumberProvider = exports.getConnectedProviderChainId = exports.getConnectedProviderType = exports.getSigner = exports.getConnectedProvider = exports.getNetworkWeb3Provider = exports.getNetworkProvider = exports._setAppChainId = exports._getAppChainId = void 0;

var decentraland_connect_1 = require("decentraland-connect");

var chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");

var ethers_1 = require("ethers");

var provider_type_1 = require("@dcl/schemas/dist/dapps/provider-type");

var chainConfiguration_1 = require("./chainConfiguration");

var utils_1 = require("./utils");
/**
 * Internal getter/setter to store the app chain id
 */


var appChainId;
/**
 * @internal
 */

function _getAppChainId() {
  return appChainId;
}

exports._getAppChainId = _getAppChainId;
/**
 * @internal
 * @param _appChainId
 */

function _setAppChainId(_appChainId) {
  appChainId = _appChainId;
}

exports._setAppChainId = _setAppChainId;

function getNetworkProvider(chainId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var connectedProvider, connectedChainId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getConnectedProvider();

          case 2:
            connectedProvider = _context.sent;

            if (!connectedProvider) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return new ethers_1.ethers.providers.Web3Provider(connectedProvider).getSigner().getChainId();

          case 6:
            connectedChainId = _context.sent;

            if (!(chainId === connectedChainId)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", connectedProvider);

          case 9:
            return _context.abrupt("return", decentraland_connect_1.connection.createProvider(provider_type_1.ProviderType.NETWORK, chainId));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.getNetworkProvider = getNetworkProvider;

function getNetworkWeb3Provider(chainId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var provider;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getNetworkProvider(chainId);

          case 2:
            provider = _context2.sent;
            return _context2.abrupt("return", new ethers_1.ethers.providers.Web3Provider(provider));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.getNetworkWeb3Provider = getNetworkWeb3Provider;

function getConnectedProvider() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _yield$decentraland_c, provider;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return decentraland_connect_1.connection.tryPreviousConnection();

          case 3:
            _yield$decentraland_c = _context3.sent;
            provider = _yield$decentraland_c.provider;
            return _context3.abrupt("return", provider ? provider : null);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", null);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));
}

exports.getConnectedProvider = getConnectedProvider;

function getSigner() {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var provider, eth;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getConnectedProvider();

          case 2:
            provider = _context4.sent;

            if (provider) {
              _context4.next = 5;
              break;
            }

            throw new Error('Could not connect to provider');

          case 5:
            eth = new ethers_1.ethers.providers.Web3Provider(provider);
            return _context4.abrupt("return", eth.getSigner());

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.getSigner = getSigner;

function getConnectedProviderType() {
  var connectionData = decentraland_connect_1.connection.getConnectionData();
  return connectionData ? connectionData.providerType : null;
}

exports.getConnectedProviderType = getConnectedProviderType;

function getConnectedProviderChainId() {
  var connectionData = decentraland_connect_1.connection.getConnectionData();
  return connectionData ? connectionData.chainId : null;
}

exports.getConnectedProviderChainId = getConnectedProviderChainId;

function isCucumberProvider() {
  var provider = window.ethereum;
  return (0, utils_1.isMobile)() && !!provider && !!provider.isCucumber;
}

exports.isCucumberProvider = isCucumberProvider;

function isDapperProvider() {
  var provider = window.ethereum;
  return !!provider && !!provider.isDapper;
}

exports.isDapperProvider = isDapperProvider;

function isCoinbaseProvider() {
  var provider = window.ethereum;
  return !!provider && !!provider.isToshi;
}

exports.isCoinbaseProvider = isCoinbaseProvider;

function isValidChainId(chainId) {
  return Object.values(chain_id_1.ChainId).includes(Number(chainId));
}

exports.isValidChainId = isValidChainId;

function getChainIdByNetwork(network) {
  var appChainId = _getAppChainId();

  if (!appChainId) {
    throw new Error('Could not get app chain id');
  }

  var config = (0, chainConfiguration_1.getChainConfiguration)(appChainId);
  return config.networkMapping[network];
}

exports.getChainIdByNetwork = getChainIdByNetwork;